import axios from "axios";
import config from "./config";
import Cookies from "js-cookie";

const uri = process.env.REACT_APP_URL;
const access_token = config.key.token;
const refresh_token = config.key.refreshToken;

const Axios = axios.create({ baseURL: uri + "v1", withCredentials: true });

Axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get(access_token);

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  },
);

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = Cookies.get(refresh_token);
        const refreshResponse = await axios.post(
          `${uri}v1/auth/refresh`,
          {
            token: refreshToken,
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${Cookies.get(access_token)}`,
            },
          },
        );

        if (refreshResponse.status === 200) {
          const newAccessToken = refreshResponse?.data?.data?.accessToken;

          Cookies.set(access_token, newAccessToken);

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

          return Axios(originalRequest);
        }
      } catch (refreshError) {
        console.error("Refresh token failed", refreshError);

        Cookies.remove(access_token);
        Cookies.remove(refresh_token);

        if (
          window.location.pathname !== "/auth/sign-in" &&
          window.location.pathname !== "/auth/reset-password"
        ) {
          window.location.href = "/auth/sign-in";
        }

        return Promise.reject(refreshError);
      }
    }

    if (
      error.response &&
      error.response.status === 401 &&
      error.response?.data?.message === "You're not authenticated"
    ) {
      if (
        window.location.pathname !== "/auth/sign-in" &&
        window.location.pathname !== "/auth/reset-password"
      ) {
        // Clear tokens before redirect
        Cookies.remove(access_token);
        Cookies.remove(refresh_token);
        window.location.href = "/auth/sign-in";
      }
    }

    // If the error is not due to token expiration or retry fails, reject the error
    return Promise.reject(error);
  },
);

export const BaseURL = uri;
export default Axios;
